import { useEffect, useState } from "react";

// Returns the current time in ms, refreshed every `intervalMs` and
// IMMEDIATELY when the tab becomes visible again (mobile browsers throttle
// background timers, so a tab left open overnight would otherwise show a
// stale "now").
export default function useTicker(intervalMs = 60_000) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const refresh = () => setNow(Date.now());
    const id = setInterval(refresh, intervalMs);
    const onVisibility = () => {
      if (document.visibilityState === "visible") refresh();
    };
    const onFocus = () => refresh();
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", onFocus);
    };
  }, [intervalMs]);

  return now;
}
